import { render, staticRenderFns } from "./SettingsCommercialClients.vue?vue&type=template&id=05550426&scoped=true&"
import script from "./SettingsCommercialClients.vue?vue&type=script&lang=js&"
export * from "./SettingsCommercialClients.vue?vue&type=script&lang=js&"
import style0 from "./SettingsCommercialClients.vue?vue&type=style&index=0&id=05550426&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05550426",
  null
  
)

export default component.exports